<app-organizer-shared-layout-funnel
  class="organizer-activity-planning-page-my-planning-validation"
>
  <form (ngSubmit)="submit()">
    <app-organizer-shared-calendar
      [creationTimeslots]="creationTimeslots"
      [timeslots]="existingTimeslots"
      [clickableTimeslots]="false"
    ></app-organizer-shared-calendar>

    <app-organizer-shared-navigation-buttons
      previousQueryParametersHandling="preserve"
      [nextLabel]="
        'activity_planning.my_planning_validation.navigation_buttons.next_label'
          | translate
            : {
                totalTimeslotToCreate: totalTimeslotToCreate,
              }
      "
      [nextVariant]="vtmnButtonVariant.CONVERSION"
      [nextDisabled]="isNextDisabled"
      [nextSubmit]="true"
    ></app-organizer-shared-navigation-buttons>
  </form>

  <app-modal [autoClose]="false" [hasCloseButton]="false">
    <h2 modal-header>
      {{ 'activity_planning.my_planning_validation.modal.header' | translate }}
    </h2>

    <p modal-content>
      {{ 'activity_planning.my_planning_validation.modal.content' | translate }}
    </p>

    <button
      app-vtmn-play-button
      type="button"
      modal-footer
      (click)="redirectOnSuccess()"
    >
      {{ 'activity_planning.my_planning_validation.modal.confirm' | translate }}
    </button>
  </app-modal>
</app-organizer-shared-layout-funnel>
